module.exports = __webpack_public_path__ + "ffb082c3cd2edff4e1f1ac8bbf09b4cb.MP3";